import { splitPeriod } from '@/lib/utils'

export const parsePeriod = (period: string) => {
  const { year, month } = splitPeriod(period)
  const parsedYear = Number(year)
  const parsedMonth = Number(month)

  return {
    year: Number.isFinite(parsedYear) ? parsedYear : undefined,
    month: Number.isFinite(parsedMonth) ? parsedMonth : undefined
  }
}

export const filterRowsStartingFrom = <T extends { period: string }>(
  rows: T[],
  startFrom?: { year: number; month: number },
  exactPeriod?: { year: number; month: number }
) => {
  if (exactPeriod) {
    return rows.filter((row: any) => {
      const { year, month } = parsePeriod(row.period)

      return year === exactPeriod.year && month === exactPeriod.month
    })
  }

  if (!startFrom) return rows

  return rows.filter((row: any) => {
    const { year, month } = parsePeriod(row.period)

    if (year === undefined || month === undefined) return false

    return year > startFrom.year || (year === startFrom.year && month >= startFrom.month)
  })
}
